import { useEffect, useState } from "react";
import Datatable from "../../datatable/Datatable";
import Navbar from "../navbar/navbar";
import DatePicker from "react-datepicker";
import { formatDate, formatISODate, getBase64ImageFromUrl, getDailyExcelReport, getDailyReportList } from "../../services/receipt.service";
import Swal from "sweetalert2";
import { DailyReportPrint } from "../../print/dailyReportPrint";
import headerLogo from "../../assets/images/DailyPoojaReport.png"
import "./reportModule.css";
import { ReportExportActions, ReportListHeading, ReportListLoading } from "./ReportListUi";

const DailyReportComponent = () => {

    const [dailyReportList, setDailyReportList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        if (selectedDate) {
            fetchReportList(selectedDate);
        }
    }, [selectedDate]);

    const fetchReportList = async (date) => {
        setLoading(true);
        try {
            const fromDate = formatISODate(date);
            const response = await getDailyReportList(fromDate);
            if (response) {
                setDailyReportList(response);
            } else {
                Swal.fire("Error", "Failed to fetch daily report list", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const grandTotal = dailyReportList.reduce((sum, item) => sum + (item.totalAmount || 0), 0);

    const columns = [
        { name: "SN", selector: (row) => row.sn, sortable: true, align: 'text-center' },
        { name: "Receipt No", selector: (row) => row.receiptNo, sortable: true, align: 'text-start' },
        { name: "Receipt Date", selector: (row) => row.receiptDate, sortable: true, align: 'text-start' },
        { name: "Name of Devotee", selector: (row) => row.devoteeName, sortable: true, align: 'text-start' },
        { name: "Mobile", selector: (row) => row.mobile, sortable: true, align: 'text-start' },
        { name: "Seva Name", selector: (row) => row.poojaName, sortable: true, align: 'text-start' },
        { name: "Seva Date", selector: (row) => row.poojaDateTime1, sortable: true, align: 'text-start' },
        { name: "Total Amount", selector: (row) => row.totalAmount, sortable: true, align: 'text-start' },
    ];

    const mappedData = () => {
        return dailyReportList.map((item, index) => ({
            sn: index + 1,
            receiptNo: item.receiptNo || '-',
            receiptDate: formatDate(item.receiptDate) || '-',
            devoteeName: item.devoteeName || '-',
            mobile: item.mobile || '-',
            poojaName: item.poojaName || '-',
            poojaDateTime1: formatDate(item.poojaDateTime1) || '-',
            totalAmount: item.totalAmount || '-',
        }))
    }

    const handlePrint = async () => {
        const base64Logo = await getBase64ImageFromUrl(headerLogo);
        await DailyReportPrint(selectedDate, base64Logo, dailyReportList);
    };


    const handleDownload = async () => {
        const fromDate = formatISODate(selectedDate);
        const response = await getDailyExcelReport(fromDate);
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "dailyReport.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };


    return (
        <div className="card report-list-page">
            <Navbar />
            <ReportListHeading title="Daily Report List" />
            <div className="report-list-toolbar rowHeadercolor">
                <div className="report-list-filters col-md-7 d-flex">
                    <div className="d-flex align-items-center">
                        <label className="fw-bold me-2 text-nowrap">
                            Select Date:
                        </label>
                        <DatePicker
                            className="form-control"
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            dateFormat="dd-MM-yyyy"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                        />
                    </div>
                </div>
                <ReportExportActions onPrint={handlePrint} onDownload={handleDownload} disabled={loading} />
            </div>
            <div id="card-body customized-card" className="report-list-table">
                {loading ? <ReportListLoading message="Loading daily report..." /> : <Datatable columns={columns} data={mappedData()} />}
            </div>
            <div className="report-list-summary">
                <h5 className="fw-bold">Grand Total: ₹ {grandTotal.toFixed(2)}</h5>
            </div>
        </div>
    );
}

export default DailyReportComponent;